<div class="glob">
    <div class="toPrint">
        <img class="logoImp" src="assets/Ixell fond blanc.jpg" alt="" />
        <h2 class="rightImp">Formule</h2>
    </div>
    <div class="details">
        <div class="reference">

            <div class="infoImp-container">
                <div class="infoImp-container-1">

                    <div class="column fin toPrint">
                        <div class="infoImp-container-labelFlex">
                            <label class="info" [translate]="'details.manufacturer'"></label>:<label class="val"> {{reference.manufacturer}}</label><label *ngIf="searchCrit.searchWorld">&nbsp;,&nbsp;{{reference.region}}</label>
                        </div>
                    </div>
                    <div class="column fin toPrint">
                        <div class="infoImp-container-labelFlex">
                            <label class="info" [translate]="'details.designation'"></label>:<label class="val">{{reference.designation}}</label>
                        </div>
                    </div>
                    <div class="fin doublecol">
                        <div class="marginRow">
                            <div id="colorRectDetails" class="noPrint"></div>
                            <div class="infoImp-container-labelFlex">
                                <label class="code" [translate]="'details.code'"></label>:<label class="val">{{reference.code}}</label> <label *ngIf="reference.variante">&nbsp;/{{reference.variante}}</label><label class="noPrint">&nbsp;,&nbsp;{{reference.manufacturer}}</label><label class="noPrint" *ngIf="searchCrit.searchWorld">&nbsp;,&nbsp;{{reference.region}}</label>
                            </div>
                        </div>
                        <div class="colDate">
                            <label class="date" [translate]="'details.year'"></label>:<label class="val">{{reference.dateFrom}} <i aria-hidden="true" class="fas fa-arrow-right"></i>{{reference.dateTo}}</label>
                        </div>
                    </div>


                </div>

                <div class="infoImp-container-2">

                    <div class="infoImp-container-2-1">
                        <div class="column fin">
                            <div class="infoImp-container-labelFlex">
                                <label class="info" [translate]="'details.shadeguidenum'"></label>:<label class="val">{{reference.shadeGuideNum}}</label>
                            </div>
                        </div>

                        <div class="column fin">
                            <div class="infoImp-container-labelFlex">
                                <label class="info" [translate]="'details.formulenum'"></label>:<label class="val">{{reference.formuleNum}}</label>
                            </div>
                        </div>

                        <div class="column">
                            <div class="ligne inlinePrint">
                                <div class="marginRow infoImp-container-labelFlex" *ngIf="reference.lignes">
                                    <label class="info">{{'details.techno'|translate}}</label>:
                                    <select pInputSelect [(ngModel)]="index" (ngModelChange)="selectLigne()" class="technoDD val">
                                        <option *ngFor="let l of reference.lignes; let i=index" [ngValue]="i">{{l.famille}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="Action inlinePrint infoImp-container-2-2" *ngIf="ligne && !ligne.hideProduct">
                        <div class="quantity">
                            <div class="actionSlider">
                                <div class="input">
                                    <div class="actionSlider-input">
                                        <label class="qteLbl"><span>{{'details.quantitySansUnite'|translate}}</span></label>
                                        <mat-select class="noPrint selectUniteFormule" [(value)]="uniteSelected" (selectionChange)="selectUniteFormule()">
                                            <mat-option class="selectUniteFormuleOption" value="L">{{'details.uniteLitre'|translate}}</mat-option>
                                            <mat-option class="selectUniteFormuleOption" value="Kg">{{'details.uniteKg'|translate}}</mat-option>
                                        </mat-select>
                                        <label class="toPrint">:{{qte}} <span *ngIf="uniteSelected == 'L'; else uniteSelectedToPrintElse">{{'details.litre'|translate}}</span><ng-template #uniteSelectedToPrintElse><span>{{'details.kilogramme'|translate}}</span></ng-template></label>
                                    </div>
                                    <input class="noPrint" type="number" id="qte" [(ngModel)]="qte" min="0.01" max="7" step="0.01" (keyup.enter)="hideKeyboard()" />
                                </div>
                                <div id="qteSlider">
                                    <mat-slider min="0.01" max="7" step="0.01" value="1" discrete showTickMarks>
                                        <input matSliderThumb [(ngModel)]="qte">
                                    </mat-slider>
                                </div>
                            </div>
                            <div class="actionButtons">
                                <button class="print" (click)="printForm()">
                                    <i aria-hidden="true" class="fal fa-print color-white fa-3x"></i>
                                </button>
                                <button class="QRcode noPrint" (click)="openQrCode()">
                                    <img class="QRcode-img" src="assets/qr-code.png" alt="" />
                                    QRCODE
                                </button>

                                <button *ngIf="isCtc" class="QRcode noPrint" (click)="openCategoryTarif()">
                                    <i aria-hidden="true" class="fal fa-3x color-white fa-calculator"></i>
                                </button>

                                <button *ngIf="this.category != '' && isCtc" class="QRcode noPrint PAE-RTU" (click)="openChoixPAE_DLL()">
                                    <div class="PAE-RTU-text">PAE</div>
                                    <div class="PAE-RTU-text">RTU</div>
                                </button>

                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="container-fluid infoformule">
                <div class="row">
                    <div class="formule col-sm-10 col-12 mx-auto" *ngIf="ligne != null">

                        <!-- Formule -->
                        <label>{{'details.formule' | translate}} :</label>
                        <mat-table [dataSource]="ligne.formule" id="formuleTab" (contentChanged)="initFooter()">
                            <ng-container matColumnDef="code">
                                <mat-header-cell *matHeaderCellDef [translate]="'details.tabCode'"></mat-header-cell>
                                <mat-cell *matCellDef="let res"><span class="left">{{res.code}}</span></mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                </ng-container>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef [translate]="'details.name'"></mat-header-cell>
                                <mat-cell *matCellDef="let res"><span class="left">{{res.name}}</span></mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                </ng-container>
                            </ng-container>
                            <!--<ng-container matColumnDef="volume">
                                <mat-header-cell *matHeaderCellDef>Volume (L)</mat-header-cell>
                                <mat-cell *matCellDef="let res">{res.volume * qte| number : '1.1-3'}}</mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                </ng-container>
                            </ng-container>-->
                            <ng-container matColumnDef="weight">
                                <mat-header-cell *matHeaderCellDef [translate]="'details.weight'"></mat-header-cell>
                                <mat-cell *matCellDef="let res">{{res.weight * qte / densiteFormule | number : '1.1-1'}}</mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                </ng-container>
                            </ng-container>
                            <ng-container matColumnDef="cumul">
                                <mat-header-cell *matHeaderCellDef [translate]="'details.sum'"></mat-header-cell>
                                <mat-cell *matCellDef="let res">{{res.cumul * qte / densiteFormule | number : '1.1-1'}}</mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef>Coût total :</mat-footer-cell>
                                </ng-container>
                            </ng-container>
                            <ng-container matColumnDef="prix">
                                <mat-header-cell *matHeaderCellDef>{{'renting.rentingPrix' | translate}} (€)</mat-header-cell>
                                <mat-cell *matCellDef="let res">
                                    {{res.prixlitre * ((res.weight * qte / densiteFormule) / res.densite / 1000) | number : '1.1-2'}}
                                </mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef>
                                        {{prixLitreTotal() | number : '1.1-2'}}
                                    </mat-footer-cell>
                                </ng-container>
                            </ng-container>

                            <mat-header-row [ngClass]="'formuleTabRowHeader'" *matHeaderRowDef="displayedColumns;"></mat-header-row>
                            <mat-row [ngClass]="'formuleTabRow'" *matRowDef="let row; columns: displayedColumns"></mat-row>
                            <ng-container>
                                <mat-footer-row [ngClass]="'formuleTabRowFooter'" *matFooterRowDef="displayedColumns;"></mat-footer-row>
                            </ng-container>
                        </mat-table>

                        <!-- PAE -->
                        <label *ngIf="lignePAE != null && haveDilutionPAE">{{'details.formule' | translate}} {{'details.PAE' | translate}} <span id="haveDilutionPAE-detail-titre">{{haveDilutionPAEDetailTitre}}</span> :</label>
                        <mat-table *ngIf="lignePAE != null && haveDilutionPAE" [dataSource]="lignePAE.formule" id="formuleTab" (contentChanged)="initFooter()">
                            <ng-container matColumnDef="code">
                                <mat-header-cell *matHeaderCellDef [translate]="'details.tabCode'"></mat-header-cell>
                                <mat-cell *matCellDef="let res"><span class="left">{{res.code}}</span></mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                </ng-container>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef [translate]="'details.name'"></mat-header-cell>
                                <mat-cell *matCellDef="let res"><span class="left">{{res.name}}</span></mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                </ng-container>
                            </ng-container>
                            <!--<ng-container matColumnDef="volume">
                                <mat-header-cell *matHeaderCellDef>Volume (L)</mat-header-cell>
                                <mat-cell *matCellDef="let res">{res.volume * qte| number : '1.1-3'}}</mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                </ng-container>
                            </ng-container>-->
                            <ng-container matColumnDef="weight">
                                <mat-header-cell *matHeaderCellDef [translate]="'details.weight'"></mat-header-cell>
                                <mat-cell *matCellDef="let res">{{res.weight * qte / densiteFormulePAE | number : '1.1-1'}}</mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                </ng-container>
                            </ng-container>
                            <ng-container matColumnDef="cumul">
                                <mat-header-cell *matHeaderCellDef [translate]="'details.sum'"></mat-header-cell>
                                <mat-cell *matCellDef="let res">{{res.cumul * qte / densiteFormulePAE | number : '1.1-1'}}</mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef>Coût total :</mat-footer-cell>
                                </ng-container>
                            </ng-container>
                            <ng-container matColumnDef="prix">
                                <mat-header-cell *matHeaderCellDef>{{'renting.rentingPrix' | translate}} (€)</mat-header-cell>
                                <mat-cell *matCellDef="let res">
                                    {{res.prixlitre * ((res.weight * qte / densiteFormulePAE) / res.densite / 1000) | number : '1.1-2'}}
                                </mat-cell>
                                <ng-container>
                                    <mat-footer-cell *matFooterCellDef>
                                        {{prixLitreTotalPAE() | number : '1.1-2'}}
                                    </mat-footer-cell>
                                </ng-container>
                            </ng-container>

                            <mat-header-row [ngClass]="'formuleTabRowHeader'" *matHeaderRowDef="displayedColumns;"></mat-header-row>
                            <mat-row [ngClass]="'formuleTabRow'" *matRowDef="let row; columns: displayedColumns"></mat-row>
                            <ng-container>
                                <mat-footer-row [ngClass]="'formuleTabRowFooter'" *matFooterRowDef="displayedColumns;"></mat-footer-row>
                            </ng-container>
                        </mat-table>

                        <div class="formuleInfo mx-auto col-8">
                            <label *ngFor="let i of ligne.lstInfos" class="{{i.type}}">{{i.libelle}}</label>
                        </div>
                        <div *ngIf="models" class="noPrint">
                            <h3 [translate]="'search.model'" class="center" *ngIf="models.length > 0"></h3>
                        </div>
                        <div class="container-fluid noPrint">
                            <div class="models row d-flex justify-content-between">
                                <label *ngFor="let m of models" class="col-3 model">{{m}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="toPrint centerqr" *ngIf="qrcode">
                <img src="data:image/png;base64,{{qrcode}}" alt="" />
            </div>
        </div>
    </div>
</div>
<div id="Modal" class="modal noPrint">
    <div class="modal-content">
        <div class="centerqr" *ngIf="qrcode">
            <img src="data:image/png;base64,{{qrcode}}" alt="" />
        </div>
        <button class="mx-auto" (click)="closeModal()">{{'activlist.fermer'|translate}}</button>
    </div>
</div>

<div id="ModalCategoryTarif" class="modal noPrint">
    <div class="modal-content">

        <div>
            <mat-radio-group [(ngModel)]="category">
                <div>
                    <mat-radio-button (change)="setCategoryCtc($event)" value="">{{'references.TarifCategory'|translate}}</mat-radio-button>
                </div>

                <div *ngIf="listCategorie.length > 0">{{libTarif}}</div>
                <div *ngIf="listCategorie.length > 0">
                    <div *ngFor="let cat of listCategorie">
                        <mat-radio-button (change)="setCategoryCtc($event)" value="{{cat}}">{{cat}}</mat-radio-button>
                    </div>
                    <!--<div><mat-radio-button (change)="setCategoryCtc($event)" value="R0">R0</mat-radio-button></div>
                    <div><mat-radio-button (change)="setCategoryCtc($event)" value="R1">R1</mat-radio-button></div>
                    <div><mat-radio-button (change)="setCategoryCtc($event)" value="R2">R2</mat-radio-button></div>
                    <div><mat-radio-button (change)="setCategoryCtc($event)" value="R3">R3</mat-radio-button></div>-->
                </div>

                <mat-radio-button *ngIf="listCategorie.length == 0" (change)="setCategoryGeneriqueCtc($event)" value="generique">{{libTarif}}</mat-radio-button>


            </mat-radio-group>
        </div>

        <button class="mx-auto" (click)="closeCategoryTarif()">{{'activlist.fermer'|translate}}</button>
    </div>
</div>

<div id="ModalDLL_PAE" class="modal noPrint">
    <div class="modal-content">

        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeChoixPAE_DLL();">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
            </span>
            <h1 class="modal-title">{{reference.technology}}</h1>
            <h4 class="modal-subtitle">
                {{subtitlePAEDLL}}
            </h4>
            <hr />
        </div>

        <div *ngIf="seeListChoixVernis && !seeColorWebPAE && !seeRangeDilution" class="ModalDLL_PAE-ListChoixVernis">

            <div class="ModalDLL_PAE-ChoixVernis" (click)="traitementEtapeDillution_s10_2('690')">Flash (Vernis flash)</div>
            <div class="ModalDLL_PAE-ChoixVernis" (click)="traitementEtapeDillution_s10_2('766')">Flash evolution (Vernis flash evo)</div>
            <div class="ModalDLL_PAE-ChoixVernis" (click)="traitementEtapeDillution_s10_2('517')">Ixalis-evol (Ixalis evolution)</div>
            <div class="ModalDLL_PAE-ChoixVernis" (click)="traitementEtapeDillution_s10_2('718')">Lexiclear (Vernis lexiclear)</div>

        </div>

        <div *ngIf="!seeListChoixVernis && seeColorWebPAE && !seeRangeDilution" class="ModalDLL_PAE-ixellColorWebPAE">

            <div class="listChoixColorWebPAE">
                <div *ngFor="let choix of ixellColorWebPAECourant" class="ModalDLL_PAE-choixIxellColorWebPAE" (click)="GetOptionDillutionPAE(choix)">
                    <span *ngIf="choix.messagesol1; else elseChoixMessage">{{choix.messagesol1}}</span>
                    <ng-template #elseChoixMessage>
                        {{choix.bnom}} [{{choix.bcode}}]
                    </ng-template>
                </div>
            </div>

            <div class="tableSelectionColorWebPAE">
                <table class="tableColorWebPAE table table-bordered">
                    <thead class="theadColorWebPAE">
                        <tr class="rowColorWebPAE">
                            <th class="cellColorWebPAE">{{'details.code'|translate}}</th>
                            <th class="cellColorWebPAE">{{'details.designation'|translate}}</th>
                            <th class="cellColorWebPAE">{{'details.ratio'|translate}}</th>
                        </tr>
                    </thead>
                    <tbody class="tbodyColorWebPAE">

                        <tr *ngFor="let selectedColorWebPAE of listChoixIxellColorWebPAE" class="rowColorWebPAE rowColorWebPAE-cleappli-{{selectedColorWebPAE.cleappli}} rowColorWebPAE-typesol-{{selectedColorWebPAE.typesol}}">
                            <td class="cellColorWebPAE">
                                <span *ngIf="selectedColorWebPAE.bnum != 0">
                                    {{selectedColorWebPAE.bcode}}
                                </span>
                            </td>
                            <td class="cellColorWebPAE">
                                <span *ngIf="selectedColorWebPAE.bnum == 0; else selectedColorWebPAEbnom">
                                    {{selectedColorWebPAE.titre1}}
                                </span>
                                <ng-template #selectedColorWebPAEbnom>
                                    {{selectedColorWebPAE.bnom}}
                                </ng-template>
                            </td>
                            <td class="cellColorWebPAE">

                                <span *ngIf="selectedColorWebPAE.codeMethode == 0; else codeMethodeEgal1">{{selectedColorWebPAE.ratio1 | number : '1.2-3'}}%</span>
                                <ng-template #codeMethodeEgal1>
                                    <span *ngIf="selectedColorWebPAE.bvolume == 0; else bvolumeEgal1">{{selectedColorWebPAE.ratio1 | number : '1.2-3'}}g</span>
                                </ng-template>
                                <ng-template #bvolumeEgal1>
                                    <span *ngIf="selectedColorWebPAE.ratio1 > 0">{{selectedColorWebPAE.ratio1 | number : '1.2-3'}}</span>
                                </ng-template>
                            </td>
                        </tr>

                        <!--<tr class="rowColorWebPAE">
                            <td class="cellColorWebPAE"></td>
                            <td class="cellColorWebPAE"></td>
                            <td class="cellColorWebPAE"></td>
                        </tr>-->

                    </tbody>
                </table>
            </div>
        </div>

        <div *ngIf="!seeListChoixVernis && !seeColorWebPAE && seeRangeDilution" class="ModalDLL_PAE-ListChoixVernis">

        </div>

        <div class="listeBoutonDilution">
            <button *ngIf="buttonCloseDilution" class="mx-auto" (click)="closeChoixPAE_DLL()">{{'activlist.fermer'|translate}}</button>
            <button *ngIf="buttonPrevDilution" class="mx-auto" (click)="prevChoixPAE_DLL()">{{'scaleform.precedent'|translate}}</button>
            <button *ngIf="buttonNextDilution" class="mx-auto" (click)="nextChoixPAE_DLL()">{{'scaleform.suivant'|translate}}</button>
        </div>
    </div>
</div>
